import { values } from 'lodash'

export const GRID_BLOCK_TYPE = {
  colored: 'colored',
  comment: 'comment',
  custom: 'custom',
  grades: 'grades',
}

export const GRID_BLOCK_TYPE_ARRAY = values(GRID_BLOCK_TYPE)
